<template>
  <div class="subNav">
    <div :class="[isActive(data.value) ? 'active' : '', subNavBtn]"
      v-for='(data, index) in dataList' @click='tabClick(data.value)' :key="index" v-if="geoView(index)">
      <v-icon>{{data.icon}}</v-icon><span>{{data.text}}</span>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'subNav',
    props: {
      clickNavMenu: Function
    },
    data () {
      return {
        dataList: [
          { value: 'overview', text: 'Overview', icon: 'assessment' },
          { value: 'contract', text: '상품별', icon: 'assignment' },
          { value: 'size', text: '사이즈별', icon: 'zoom_out_map' },
          { value: 'creative', text: '소재별', icon: 'image' },
          { value: 'creativeGroup', text: '소재 그룹별', icon: 'collections' },
          { value: 'geo', text: '지역별', icon: 'my_location' }
        ],
        subNavBtn: 'subNavBtn'
      }
    },
    computed: {
      ...mapState({
        campaignDetailTap: state => state.campaign.campaignDetailTap,
        isGeo: state => state.campaign.isGeo
      })
    },
    methods: {
      ...mapMutations([
        'setCampaignDetailTap'
      ]),
      isActive (type) {
        return this.campaignDetailTap === type
      },
      geoView (n) {
        if (n !== 5 || this.isGeo) return true
        return false
      },
      tabClick (value) {
        this.clickNavMenu()
        // this.setCampaignDetailTap(value)
        switch (value) {
          case 'overview':
            this.$router.push('/campaign')
            break
          case 'contract':
            this.$router.push('/campaign/ad')
            break
          case 'size':
            this.$router.push('/campaign/size')
            break
          case 'creative':
            this.$router.push('/campaign/creative')
            break
          case 'creativeGroup':
            this.$router.push('/campaign/creativeGroup')
            break
          case 'geo':
            this.$router.push('/campaign/geo')
            break
        }
      }
    }
  }
</script>

<style scoped>
  .subNavBtn {
    width: calc(100% - 23px);
    padding-left: 15px;
    color: #505050;
  }
  .subNavBtn:hover {
    cursor: pointer;
    background: rgb(247, 249, 250);
    border-left: 8px solid #66CC33;
    z-index: 1;
  }
  .active.subNavBtn {
    border-left: 8px solid #66CC33;
    background: rgb(247, 249, 250);
  }

  .subNavBtn {
    height: 40px;
    line-height: 40px;
    border-left: 8px solid #eaeaea;
  }
  i {
    color: #689f38;
    vertical-align: middle;
    margin-right: 10px;
    font-size: 22px;
  }
</style>


// WEBPACK FOOTER //
// SubNav.vue?1271460f